/**
 * move shopping tools and minicart into a wrapper
 */
(() => {
  const header = document.querySelector('header .header-full .head-main-3 .vertical-align');
  const shoppingTools = document.querySelector('header .header-full .head-main-3 .shoppingtools_container');
  const minicart = document.querySelector('header .header-full .head-main-3 .minicart_container');
  const search = document.querySelector('header .header-full .head-main-3 .search_container');
  if (header) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('shoppingtools_minicart_wrapper');

    if (search) {
      wrapper.append(search);
    }
    if (minicart) {
      wrapper.append(minicart);
    }
    if (shoppingTools) {
      wrapper.append(shoppingTools);
    }

    header.append(wrapper);
  }
})();
